<template>
  <nav-bar title="新增订单" />
  <Content :bottom="0">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getDataLoading" />
    <customer-info />
    <!-- 地址 -->
    <div class="address-group">
      <van-cell
        value-class="cell-values"
        title="联系人"
        :value="address.recipientsName"
      />
      <van-cell
        value-class="cell-values"
        title="联系电话"
        :value="address.telphone"
      />
      <van-cell
        value-class="cell-values"
        title="用户地址"
        :value="address.fullAddr"
      />
    </div>
    <van-form style="margin-top: 16px" validate-trigger="onChange" @submit="handleSubmit">
      <!-- 选择商户 -->
      <Picker label="商户名称" :columns="columns" text="agentName" :border="false" :require="true" @confirm-values="onConfirm" />
      <!-- 商品列表 -->
      <van-checkbox-group v-model="checked">
        <div class="list" v-for="item in goodsList" :key="item.goodsId">
          <van-checkbox :name="item.goodsId" shape="square">{{item.goodsName}}</van-checkbox>
          <van-stepper v-model="countList[item.goodsId]" />
        </div>
      </van-checkbox-group>
      <!-- btn -->
      <div style="margin: 16px">
        <van-button block type="primary" :loading="loading" :disabled="loading" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </Content>
</template>

<script>
import { Toast } from 'vant'
import { reactive, toRefs, ref, computed } from 'vue'
import { getDefaultAddress } from '@/api/address'
import { getUserAgentList, getUserGoodsList } from '@/api/client'
import { addOrder } from '@/api/order'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useGetData } from '@/hooks/useGetData'
import { useSubmit, loading } from '@/hooks/useSubmit'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
export default {
  name: 'AddOrder',
  setup () {
    const store = useStore()
    const userId = computed(() => store.state.customer.userId)
    const state = reactive({
      address: {}
    })
    // 获取默认地址
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(getDefaultAddress, (data) => {
      state.address = data
    }, userId.value)
    getDataLoading()

    // 获取商户列表
    const columns = ref([])
    useGetData(getUserAgentList, (data) => {
      columns.value = data
    })(userId.value)

    // 获取商品列表
    const goodsList = ref([]) // 商品列表
    const getGoodsList = async (agentId) => {
      useGetData(getUserGoodsList, (data) => {
        goodsList.value = data
      })({
        agentId: agentId,
        userId: userId.value
      })
    }

    // 选择商户
    const agentId = ref('')
    const onConfirm = (values) => {
      agentId.value = values.agentId
      getGoodsList(values.agentId)
    }

    // 选择商品
    const countList = reactive({}) // 数量列表
    const checked = ref([]) // chekbox
    const selectGoods = computed(() => {
      const res = checked.value.map(item => ({
        goodsId: item,
        goodsCount: countList[item] + ''
      }))
      return res
    })

    // 提交
    const router = useRouter()
    const handleSubmit = () => {
      if (checked.value.length) {
        const params = {
          agentId: agentId.value,
          userId: userId.value,
          goodsList: selectGoods.value
        }
        const { onSubmit } = useSubmit(addOrder, params, () => {
          router.back()
        })
        onSubmit()
      } else {
        Toast('请选择商品')
      }
    }

    // 解构
    const { address } = toRefs(state)
    return {
      getDataLoading,
      showLoading,
      isLoading,
      address,
      columns,
      onConfirm,
      checked,
      goodsList,
      countList,
      selectGoods,
      handleSubmit,
      loading
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  height: 60px;
  font-size: 16px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  .icon {
    font-size: 36px;
    color: orange;
    margin-right: 5px;
  }
}
.address-group {
  margin-top: 16px;
  background-color: #ffffff;
  ::v-deep(.cell-values) {
    text-align: left !important;
  }
  ::v-deep(.van-cell__title) {
    flex: initial;
    width: 100px;
    margin-right: 20px;
  }
  /* ::v-deep(.van-field__label) {
    flex: 1;
    margin: 0;
  } */
}
.list {
  display: flex;
  background-color: #fff;
  font-size: 16px;
  height: 48px;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  margin-top: 1px;
}
</style>
